import type { FunctionComponent } from "react";

import { HamburgerMenuHeader } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-header";
import { HamburgerMenuList } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-list";
import { HamburgerMenuNonSubPanel } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-non-sub-panel";
import { HamburgerMenuWrapper } from "scmp-app/components/hamburger-menu/hamburger-menu-wrapper";
import type { Props as HamburgerMenuWrapperProps } from "scmp-app/components/hamburger-menu/hamburger-menu-wrapper";

import { MenuBody } from "./styles";

type Props = Pick<HamburgerMenuWrapperProps, "anchor">;

export const HamburgerMenuDefault: FunctionComponent<Props> = ({ anchor }) => (
  <HamburgerMenuWrapper anchor={anchor}>
    {({ handleCloseExplicit }) => (
      <>
        <HamburgerMenuHeader onCloseClick={handleCloseExplicit} />
        <MenuBody>
          <HamburgerMenuNonSubPanel />
          <HamburgerMenuList />
        </MenuBody>
      </>
    )}
  </HamburgerMenuWrapper>
);

HamburgerMenuDefault.displayName = "HamburgerMenuDefault";
